var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"container bs-docs-container mt30"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('structured')],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('affix-sidebar')],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0295a7e5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/structured.vue
// module id = 501
// module chunks = 0